/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum AuthSupportHistorySortFieldName {
  MODIFIED_DATE = 'MODIFIED_DATE'
}
